import { Canvas, useThree } from '@react-three/fiber';
import './App.css';
import React, { useEffect, useReducer, useState } from 'react';
import { Computer } from './components/Computer';
import { Space } from './components/Space';

import DiscMenu from './components/Disc3DMenu';
import { HopsCard } from './components/HopsCard';
import { BrewingCard } from './components/BrewingCard';
import { PhotographyCard } from './components/PhotographyCard';
import { CameraControls, OrbitControls, useCursor } from '@react-three/drei';
import * as THREE from 'three';
import { Perf } from 'r3f-perf';

function App() {
  const [currentScene, setCurrentScene] = useState<number>(0);
  const [currentCard, setCurrentCard] = useState<number>(0);
  const [hovered, hover] = useState(false)
  const [showPerf, togglePerf] = useReducer((state) => !state, false)
  useCursor(hovered)

  const scenes = [
    <Space zoom orbit />,
    <Canvas className="fade-in"><Computer /></Canvas>,
    <DiscMenu />,
    <Canvas dpr={1.5} camera={{ fov: 90 }} className="fade-in">
      <ambientLight intensity={1} />
      {showPerf && <Perf />}
      <Camera currentCard={currentCard} />
      <PhotographyCard onDoubleClick={() => setCurrentCard(1)} position={[-3, 0, .5]} rotation-y={.5} selected={currentCard === 1} onPointerOver={(e) => hover(true)} onPointerOut={() => hover(false)} />
      <HopsCard onDoubleClick={() => setCurrentCard(2)} selected={currentCard === 2} onPointerOver={(e) => hover(true)} onPointerOut={() => hover(false)} />
      <BrewingCard onDoubleClick={() => setCurrentCard(3)} position={[3, 0, .5]} rotation-y={-.5} selected={currentCard === 3} onPointerOver={(e) => hover(true)} onPointerOut={() => hover(false)} />
    </Canvas>

  ]

  return (<div className='App'>
    <button onClick={() => setCurrentScene(currentScene + 1 === scenes.length ? 0 : currentScene + 1)}>Change scene</button>
    {currentScene === 3 && <button onClick={togglePerf}>Toggle Perf</button>}
    {currentScene === 3 && currentCard !== 0 && <button onClick={() => setCurrentCard(0)}>back</button>}
    <div style={{ height: '100vh' }} >
      {scenes[currentScene]}
    </div>
  </div>
  )

}

function Camera({ currentCard = 0, position = new THREE.Vector3(0, 0, 5), focus = new THREE.Vector3(0, 0, 0) }) {
  const { controls, scene } = useThree()
  useEffect(() => {
    const active = scene.getObjectByName(currentCard.toString())
    if (active) {
      active?.parent?.localToWorld(position.set(0, 0.5, 0.25))
      active?.parent?.localToWorld(focus.set(0, 0, -2))
    }
    // @ts-ignore
    controls?.setLookAt(...position.toArray(), ...focus.toArray(), true)
  }, [currentCard])
  return <CameraControls makeDefault />
}

export default App;
